module.exports = __webpack_public_path__ + "img/img_app_band_fitness.3d34ca9a.png";